import React, { useMemo } from "react";
const estilosPaginacao = require("./paginacao.module.scss").default;

export type PaginacaoProps = {
  paginaAtual: number;
  totalPaginas: number;
  onAlterarListaSelecionada: (numeroIndexPagina: number) => void;
  desabilitarPaginacao?: boolean;
  id: string;
};

export const Paginacao = React.memo((props: PaginacaoProps) => {
  const indexSelecaoPagina = useMemo(() => 
    Math.floor((props.paginaAtual - 1) / 10) + 1,
    [props.paginaAtual]
  );

  const arrayPaginas = useMemo(() => {
    const start = (indexSelecaoPagina - 1) * 10;
    const end = Math.min(start + 10, props.totalPaginas);
    return Array.from({ length: end - start }, (_, i) => start + i + 1);
  }, [indexSelecaoPagina, props.totalPaginas]);

  const handlePaginaClick = (pagina: number) => {
    if (props.desabilitarPaginacao) return;
    props.onAlterarListaSelecionada(pagina);
  };

  const totalGrupos = Math.ceil(props.totalPaginas / 10);
  const primeiroGrupo = indexSelecaoPagina === 1;
  const ultimoGrupo = indexSelecaoPagina === totalGrupos;

  if (!props.totalPaginas || props.totalPaginas < 1) return null;

  return (
    <div className={estilosPaginacao.containerPaginacao}
      key={`Paginacao_${props.id ?? ""}`}
      id={`Paginacao_${props.id ?? ""}`}  
    >


      {!primeiroGrupo && props.totalPaginas > 20 && (
        <a
          title="Primeira Página"
          className={props.desabilitarPaginacao ? estilosPaginacao.disabled : ""}
          onClick={() => handlePaginaClick(1)}
          key={`Paginacao_Primeiro_${props.id ?? ""}`}
          id={`Paginacao_Primeiro_${props.id ?? ""}`}
        >
          {`<<`}
        </a>
      )}

      {!primeiroGrupo && (
        <a
          className={props.desabilitarPaginacao ? estilosPaginacao.disabled : ""}
          onClick={() => handlePaginaClick((indexSelecaoPagina - 2) * 10 + 1)}
          key={`Paginacao_Anterior_${props.id ?? ""}`}
          id={`Paginacao_Anterior_${props.id ?? ""}`}
        >
          {`<`}
        </a>
      )}

      {arrayPaginas.map((pagina) => (
        <a
          className={`
            ${pagina === props.paginaAtual ? estilosPaginacao.activePage : ""}
            ${props.desabilitarPaginacao ? estilosPaginacao.disabled : ""}
          `}
          onClick={() => handlePaginaClick(pagina)}
          key={`Paginacao_Pagina_${pagina}_${props.id ?? ""}`}
          id={`Paginacao_Pagina_${pagina}_${props.id ?? ""}`}
        >
          {pagina}
        </a>
      ))}

      {!ultimoGrupo && (
        <a
          className={props.desabilitarPaginacao ? estilosPaginacao.disabled : ""}
          onClick={() => handlePaginaClick(indexSelecaoPagina * 10 + 1)}
          key={`Paginacao_Proxima_${props.id ?? ""}`}
          id={`Paginacao_Proxima_${props.id ?? ""}`}
        >
          {`>`}
        </a>
      )}

      {!ultimoGrupo && props.totalPaginas > 20 && (
        <a
          title="Última Página"
          className={props.desabilitarPaginacao ? estilosPaginacao.disabled : ""}
          onClick={() => handlePaginaClick(props.totalPaginas)}
          key={`Paginacao_Ultima_${props.id ?? ""}`}
          id={`Paginacao_Ultima_${props.id ?? ""}`}
        >
          {`>>`}
        </a>
      )}
    </div>
  );
});